var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6777FF",
    d: "M5.258 16.742c-.475 0-.942-.125-1.375-.375a2.71 2.71 0 0 1-1.375-2.384V6.008c0-.991.516-1.883 1.375-2.383.866-.5 1.891-.5 2.75 0l6.908 3.983a2.74 2.74 0 0 1 1.375 2.384c0 .991-.517 1.883-1.375 2.383l-6.908 3.983a2.66 2.66 0 0 1-1.375.384m0-12.234a1.498 1.498 0 0 0-1.5 1.5v7.975c0 .542.283 1.025.75 1.3a1.49 1.49 0 0 0 1.5 0l6.908-3.983c.467-.275.75-.758.75-1.3s-.283-1.025-.75-1.3L6.008 4.717a1.5 1.5 0 0 0-.75-.209M16.867 15.775a.63.63 0 0 1-.625-.625V4.85a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v10.3a.624.624 0 0 1-.625.625"
  })));
};
export default SvgNext;